<template>
  <div>
    <h1>Cadastrar usuário</h1>
    <b-card no-body>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import { defineComponent, onMounted } from "vue";
import Form from "../Components/Form.vue";
import { useRouter } from "vue-router/dist/composables.js";
import { useActions } from "vuex-composition-helpers";

export default defineComponent({
  components: { Form },
  setup() {
    const $router = useRouter();
    const $actions = useActions("users", ["ActionNewUser"]);

    function loadData(id) {
      $router.push({ name: "users_edit", params: { id: id } });
    }

    onMounted(() => {
      $actions.ActionNewUser();
    });

    return {
      loadData,
    };
  },
});
</script>

<style></style>
